import cloneDeep from "lodash/cloneDeep";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { debounce } from "lodash";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import EventImagePreview from "@/components/Events/EventImagePreview/EventImagePreview.vue";
import KisList from "@/components/KIS/KisList/KisList.vue";
import KisSubjectAreaEditDialog from "@/components/KIS/KisSubjectAreaEditDialog/KisSubjectAreaEditDialog.vue";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

const defaultItem = {
  name: "",
  address: {},
  links: [],
  description: "",
  active: true
};

export default {
  name: "KisSubjectArea",
  components: {
    KisSubjectAreaEditDialog,
    KisList,
    EventImagePreview,
    ValidationDialog,
    TreeViewSelection
  },
  data: () => ({
    loading: false,
    editedItem: {},
    editDialog: false,
    filter: { name: "", limit: 10 },
    headers: [
      { text: "Name", value: "name" },
      { text: "Zuletzt geändert am", value: "updatedAt" },
      { text: "Aktiv", value: "active" },
      { text: "Aktionen", sortable: false, value: "actions" }
    ]
  }),
  async mounted() {
    this.loading = true;
    const itemsPerPage = this.itemsPerPage;
    if (itemsPerPage && !isNaN(itemsPerPage)) {
      this.filter.limit = itemsPerPage;
      this.filter.itemsPerPage = itemsPerPage;
      this.itemsPerPage = itemsPerPage;
    }
    await this.$store.dispatch("getSubjectAreas", this.filter);
    await this.getAllPersons();
    await this.$store.dispatch("getAllUsers");
    await this.$store.dispatch("getDepartments");
    await this.getAllTasks();

    this.loading = false;
  },
  methods: {
    async getAllPersons() {
      const limit = 100;

      await this.$store.dispatch("getPersons", {
        skip: this.persons.length,
        limit,
        getAll: true
      });
    },
    async getAllTasks() {
      const limit = 100;
      if (!this.taskCount) await this.$store.dispatch("getTasks");
      while (this.taskCount > this.unmappedTasks?.length) {
        await this.$store.dispatch("getTasks", {
          skip: this.unmappedTasks.length,
          limit,
          getAll: true
        });
      }
    },
    editItem(item) {
      this.editDialog = true;
      this.editedItem = cloneDeep(item);
    },
    addNewSubjectArea() {
      this.editedItem = cloneDeep(defaultItem);
      this.editDialog = true;
    },
    copyItem(item) {
      this.editedItem = cloneDeep(item);
      delete this.editedItem?._id;
      this.editDialog = true;
    },
    setSubjectArea(item) {
      this.editedItem = item;
    },
    closeDialog() {
      this.editedItem = cloneDeep(defaultItem);
      this.editDialog = false;
    },
    setFilterPage(page) {
      this.filter.page = page;
    },
    setFilterLimit(limit) {
      this.filter.limit = limit;
      this.filter.itemsPerPage = limit;
      localStorage.setItem("itemsPerPage", limit);
    },
    async getSubjectAreas(filter) {
      await this.$store.dispatch("getSubjectAreas", filter);
    },
    async updateSubjectArea(subjectArea) {
      try {
        const headers = getTokenHeader();
        if (!this.editedItem.principal_id)
          this.editedItem.principal_id = this.currentPrincipal;
        const response = await axios.put(
          `${env.kis_api_client_url}subjectarea/${subjectArea._id}`,
          subjectArea,
          {
            params: {
              principal_id: subjectArea.principal_id
            },
            headers
          }
        );
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          this.setSubjectArea(response.data);
          await this.$store.dispatch("getSubjectAreas", this.filter);
        } else {
          console.error(response);
          await this.$store.dispatch(
            "createError",
            "Es ist ein Fehler aufgetreten!"
          );
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    async deleteSubjectArea(subjectArea) {
      try {
        const confirm = await this.$confirm(
          "Möchten Sie diesen Geschäftsbereich wirklich löschen?",
          confirmWarningConfig
        );
        if (confirm) {
          const headers = getTokenHeader();
          if (!this.editedItem.principal_id)
            this.editedItem.principal_id = this.currentPrincipal;
          const response = await axios.delete(
            `${env.kis_api_client_url}subjectarea/${subjectArea._id}`,
            {
              params: {
                principal_id: subjectArea.principal_id
              },
              headers
            }
          );
          if (response.status === 200) {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gelöscht!"
            );
            await this.$store.dispatch("getSubjectAreas", this.filter);
          } else {
            console.error(response);
            await this.$store.dispatch(
              "createError",
              "Es ist ein Fehler aufgetreten!"
            );
          }
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    applySearchText: debounce(async function() {
      if (this.filter.name.length >= 3 || !this.filter.name.length)
        await this.$store.dispatch("getSubjectAreas", this.filter);
    }, 500)
  },
  computed: {
    subjectAreas() {
      return this.$store.state.subjectAreas?.map(
        area =>
          (area = {
            title: area.name,
            ...area
          })
      );
    },
    persons() {
      return this.$store.state.persons;
    },
    departments() {
      return this.$store.state.departments.map(department => ({
        title: department.name,
        ...department
      }));
    },
    unmappedTasks() {
      return this.$store.state.tasks;
    },
    tasks() {
      return this.$store.state.tasks.map(task => ({
        title: task.name,
        ...task
      }));
    },
    personCount() {
      return this.$store.state.personCount;
    },
    taskCount() {
      return this.$store.state.taskCount;
    },
    subjectAreaCount() {
      return this.$store.state.subjectAreaCount;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    }
  }
};
